import { useEffect, useMemo, useRef, useState } from 'react'
import {
  SDrawerOrModal,
  STableActions,
  SLowcodeList
} from 'shj-components'
import { httpOrgList } from '@/services/homeService.ts'
import EditModal from './extraEdit';

const ExtraModal = ({
  openModal = false,
  onClose = () => ({}),
  editData = [],
  setEditData = (val) => ({}),
  chooseType = '',
  basicInfo = {},
  isDetail = false,
}) => {
  const [openEditConfigModal, setOpenEditConfigModal] = useState(false);
  const [editId, setEditId] = useState('');
  const [submitLoading, setSubmitLoading] = useState(false);
  const [configItemData, setConfigItemData] = useState({});
  const [companyList, setCompanyList] = useState<any>([])
  const listRef = useRef<any>()

  useEffect(() => {
    const formatData = editData?.length ? editData.map((item: any, index: number) => ({ ...item, index: index + 1 })) : [];
    listRef.current?.updateDataSource(formatData, formatData?.length);
  }, [editData])

  const config = {
    rowSelection: false,
    columns: [
      {
        title: '序号',
        width: 80,
        dataIndex: 'index',
      },
      {
        title: '适用门店',
        width: 200,
        dataIndex: 'shopName',
      },
      {
        title: '升降级范围',
        width: 300,
        dataIndex: 'changeLevelScope',
        render: (text) => {
          try {
            const obj = JSON.parse(text);
            return obj?.rule;
          } catch (err) {
            return '';
          }
        }
      },
      {
        title: '预算量',
        width: 300,
        dataIndex: 'budgetQuantityRule',
        render: (text) => {
          try {
            const obj = JSON.parse(text);
            return obj?.rule;
          } catch (err) {
            return '';
          }
        }
      },
      {
        title: '是否允许复制',
        width: 150,
        dataIndex: 'isCopy',
        render: (val) => (<span>{ val ? '是' : '否' }</span>)
      },
      {
        title: '下单时是否显示',
        width: 150,
        dataIndex: 'isShowOrder',
        render: (val) => (<span>{ val ? '是' : '否' }</span>)
      },
      {
        title: '操作',
        dataIndex: '#',
        render: 'actionRender',
        fixed: 'right',
        width: 150,
      },
    ],
    footer: [
      {
        label: '新增配置',
        type: 'primary',
        events: ['onClick:onAddConfig'],
        disabled: basicInfo?.isExpire || basicInfo?.expirationTime,
      },
    ],
    search: [
      {
        label: '适用门店',
        name: 'orgId',
        itemType: 'select',
        data: 'companyList',
        mode: 'multiple',
        labelKey: 'name',
        key: 'id',
      },
    ],
  }

  const config1 = {
    rowSelection: false,
    columns: [
      {
        title: '序号',
        width: 80,
        dataIndex: 'index',
      },
      {
        title: '适用门店',
        width: 200,
        dataIndex: 'shopName',
      },
      {
        title: '是否可减项',
        width: 150,
        dataIndex: 'isSubtract',
        render: (val) => (<span>{ val ? '是' : '否' }</span>)
      },
      {
        title: '是否允许复制',
        width: 150,
        dataIndex: 'isCopy',
        render: (val) => (<span>{ val ? '是' : '否' }</span>)
      },
      {
        title: '是否标配',
        width: 150,
        dataIndex: 'standardFlag',
        render: (val) => (<span>{ val ? '是' : '否' }</span>)
      },
      {
        title: '预算量',
        width: 300,
        dataIndex: 'budgetQuantityRule',
        render: (text) => {
          try {
            const obj = JSON.parse(text);
            return obj?.rule;
          } catch (err) {
            return '';
          }
        }
      },
      {
        title: '预算量是否可编辑',
        width: 150,
        dataIndex: 'allowUpdateBudgetQuantity',
        render: (val) => (<span>{ val ? '是' : '否' }</span>)
      },
      {
        title: '下单时是否显示',
        width: 150,
        dataIndex: 'isShowOrder',
        render: (val) => (<span>{ val ? '是' : '否' }</span>)
      },
      {
        title: '操作',
        dataIndex: '#',
        render: 'actionRender',
        fixed: 'right',
        width: 150,
      },
    ],
    footer: [
      {
        label: '新增配置',
        type: 'primary',
        events: ['onClick:onAddConfig'],
        disabled: isDetail || basicInfo?.isExpire || basicInfo?.expirationTime,
      },
    ],
    search: [
      {
        label: '适用门店',
        name: 'orgId',
        itemType: 'select',
        data: 'companyList',
        mode: 'multiple',
        labelKey: 'name',
        key: 'id',
      },
    ],
  }

  const handleAddConfig = () => {
    setEditId('');
    setConfigItemData({});
    setOpenEditConfigModal(true);
  }

  const handleEditConfig = (record: any) => {
    setEditId(record.shopId);
    setConfigItemData({...record});
    setOpenEditConfigModal(true);
  }

  const handleSetEditData = (val) => {
    // 新增
    if (!editId) {
      const list = [...val, ...editData];
      const hasShopIdList: Array<any> = [];
      const newList = list.filter((item: any) => {
        if (hasShopIdList.includes(item.shopId)) {
          return false;
        } else {
          hasShopIdList.push(item.shopId);
          return true;
        }
      })
      // 根据适用门店去重
      setEditData(newList)
    } else {
      const newData = editData?.map((item: any) => {
        if (item.shopId === val?.[0]?.shopId) {
          return {
            ...val?.[0],
          }
        } else {
          return {
            ...item,
          }
        }
      })
      setEditData(newData)
    }
  }

  const handleDetele = (record: any) => {
    const newData = editData?.filter((item: any) => item.shopId !== record.shopId);
    setEditData(newData)
  }

  const fetchList = async (value) => {
    let formatData = editData?.length ? editData.map((item: any, index: number) => ({ ...item, index: index + 1 })) : [];
    if (value?.query?.orgId?.length) {
      formatData = formatData?.filter((item: any) => value?.query?.orgId?.includes(item.shopId)).map((item: any, index: number) => ({ ...item, index: index + 1 }));
    }
    return {
      total: formatData.length,
      records: formatData,
    }
  }

  const getOptions = async () => {
    const companyList: any = await httpOrgList()
    setCompanyList([...companyList])
    return {
      companyList
    }
  }

  const extensions = {
    request: { fetchList, getOptions },
    events: {
      onAddConfig: () => handleAddConfig(),
    },
    customRender: {
      actionRender(_, record: Record<string, any>): JSX.Element {
        return (
          <STableActions>
            <STableActions.SActionBtn disabled={isDetail || basicInfo?.isExpire || basicInfo?.expirationTime} onClick={() => { handleEditConfig(record) }}>
              编辑
            </STableActions.SActionBtn>
            <STableActions.SActionBtn disabled={isDetail || basicInfo?.isExpire || basicInfo?.expirationTime} danger onClick={() => { handleDetele(record)}}>
              删除
            </STableActions.SActionBtn>
          </STableActions>
        )
      },
    },
  }

  return (
    <>
      <div>
        <SDrawerOrModal
          width={1000}
          antdProps={{ footer: null }}
          title={'特殊配置'}
          onCancel={onClose}
          loading={submitLoading}
          open={openModal}
        >
          <SLowcodeList searchMode={'group'} ref={listRef} config={chooseType === 'PRD_PRODUCT' ? config1 : config} {...extensions} />
        </SDrawerOrModal>
        {
          openEditConfigModal &&
            <EditModal
              openModal={openEditConfigModal}
              onClose={() => setOpenEditConfigModal(false)}
              editData={configItemData}
              editId={editId}
              setEditData={handleSetEditData}
              companyList={companyList}
              chooseType={chooseType}
              basicInfo={basicInfo}
            />
        }
      </div>
    </>
  )
}

export default ExtraModal
